import React, { useState } from 'react';
import { ToggleButton } from '@mui/material';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import RadioGroupInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/RadioGroupInput';
import TextInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/TextInput';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import HeadingBlock from './index';
export default function HeadingSidebarPanel({ data, setData }) {
    var _e, _t;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = HeadingBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "Heading block" },
        React.createElement(TextInput, { label: "Content", rows: 3, defaultValue: (_e = data.props) === null || _e === void 0 ? void 0 : _e.text, onChange: (text) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { text }) }));
            } }),
        React.createElement(RadioGroupInput, { label: "Level", defaultValue: (_t = data.props) === null || _t === void 0 ? void 0 : _t.level, onChange: (level) => {
                updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { level }) }));
            } },
            React.createElement(ToggleButton, { value: "h1" }, "H1"),
            React.createElement(ToggleButton, { value: "h2" }, "H2"),
            React.createElement(ToggleButton, { value: "h3" }, "H3")),
        React.createElement(MultiStylePropertyPanel, { names: ['color', 'backgroundColor', 'fontFamily', 'fontWeight', 'textAlign', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=HeadingSidebarPanel.js.map